<template>
  <CustomTimeLine :items="collections.historyResult" />
</template>

<script>
import CustomTimeLine from 'custom-time-line';
import { getRequestHistory } from '@/modules/human-resources/api';
import { getRequestStatusColor } from '@/utils/constants/hrrequest/requestStatusCodes';
import moment from 'moment';

export default {
  name: 'History',
  components: {
    CustomTimeLine,
  },
  data() {
    return {
      collections: {
        historyResult: [],
      },
    };
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  async mounted() {
    this.onSearch();
  },
  methods: {
    async onSearch() {
      await getRequestHistory(this.value).then((res) => {
        this.collections.historyResult = res.data.map((x) => ({
          status: {
            text: x.status,
            color: getRequestStatusColor(x.statusId, true),
          },
          date: moment(x.date).format('DD/MM/YYYY'),
          text: x.user + '\r\n' + x.userRole,
        }));
      });
    },
  },
};
</script>
